import React from "react";
import "./JoinOurTeam.css"; // Add styles in this CSS file

export const JobCard = ({ title, description, tags, buttonText }) => (
  <div className="job-card">
    <div className="job-info">
      <h3 className="job-title">{title}</h3>
      <p className="job-description">{description}</p>
      <div className="job-tags">
        {tags.map((tag, index) => (
          <span key={index} className="job-tag">
            {tag}
          </span>
        ))}
        <button className="apply-button-job">{buttonText}</button>
      </div>
    </div>
    {/* <button className="apply-button-job">{buttonText}</button> */}
  </div>
);
